import React, { useEffect, useState } from "react";
import { Pressable, Text, View } from "react-native";
import CallButton from "@assets/svg/CallButton";
import handleCallButtonPress from "@utils/handleCallButtonPress";
import { AGENT_CONTACT } from "../../constants/analyticsEventsCT";

const LeaderAgentContact = (props) => {
  const [agentDetails, setAgentDetails] = useState(null);
  const { extra_data = {} } = props;

  useEffect(() => {
    setAgentDetails(extra_data);
  }, []);

  const callAgent = () => {
    handleCallButtonPress(agentDetails?.phone_number, AGENT_CONTACT.CALL);
  };
  if (!agentDetails?.full_name || !agentDetails?.phone_number) {
    return null;
  }
  return (
    <View
      style={{
        marginHorizontal: 15,
        marginVertical: 10,
        backgroundColor: "white",
        borderColor: "rgba(0,0,0,0.1)",
        paddingHorizontal: 12,
        paddingVertical: 16,
        flexDirection: "row",
        borderRadius: 10,
        borderWidth: 1,
        alignItems: "center",
      }}
    >
      <View style={{ flex: 1 }}>
        <Text style={{ fontFamily: "NotoSansDevanagari-Bold", fontSize: 16 }}>
          किसी भी समस्या के लिए कॉल करें
        </Text>
        <View style={{ flexDirection: "row", marginTop: 8 }}>
          <Text
            style={{
              color: "rgba(0,0,0,0.56)",
            }}
          >
            कम्युनिटी मैनेजर
          </Text>
          <Text
            style={{
              color: "rgba(196,196,196,1)",
            }}
          >
            {"    "}|{"    "}
          </Text>
          <Text style={{ fontFamily: "NotoSansDevanagari-Bold" }}>
            {agentDetails?.full_name}
          </Text>
        </View>
      </View>
      <Pressable
        onPress={callAgent}
        style={{
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <CallButton height={45} width={45} />
      </Pressable>
    </View>
  );
};

export default LeaderAgentContact;
